var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / no tag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Entry-details---Driver-(View-mode)",
    transform: "translate(-846.000000, -521.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "details-group",
    transform: "translate(152.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stats",
    transform: "translate(49.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unknown-Profile-Copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "photo-1-copy-4",
    transform: "translate(222.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1",
    transform: "translate(423.000000, 228.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-no-tag",
    transform: "translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,14.5 L14.4906509,1.50934909",
    id: "Line-2",
    strokeLinecap: "square"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTag);
export default __webpack_public_path__ + "static/media/no_tag.f9d28fc7a85485076a642f358f180d21.svg";
export { ForwardRef as ReactComponent };